// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  PathArgs = 1,
  LineComment = 2,
  Program = 3,
  FontDirective = 4,
  String = 5,
  Identifier = 6,
  Number = 7,
  ViewBoxDefinition = 9,
  define = 10,
  ViewBox = 11,
  TernaryExpression = 13,
  BinaryExpression = 16,
  UnaryExpression = 31,
  TemplateLiteral = 33,
  TemplateInterpolation = 34,
  BooleanLiteral = 35,
  NullLiteral = 36,
  ColorLiteral = 37,
  CSSColorLiteral = 38,
  ArrayLiteral = 41,
  SpreadElement = 42,
  ObjectLiteral = 47,
  ObjectProperty = 48,
  StyleBlockLiteral = 49,
  StyleBody = 50,
  StyleContent = 51,
  StyleInterp = 52,
  PathBlockExpression = 53,
  TextBlockExpression = 54,
  CalcExpression = 56,
  calc = 57,
  LayerConstructor = 58,
  LayerType = 59,
  LayerCallExpression = 60,
  layer = 61,
  ParenExpression = 62,
  RangeExpression = 63,
  RangeOp = 64,
  HalfOpenRangeOp = 65,
  SwitchExpression = 66,
  _switch = 67,
  CaseArm = 68,
  _case = 69,
  CasePattern = 70,
  RangePattern = 71,
  WhereGuard = 72,
  where = 73,
  DefaultArm = 74,
  _default = 75,
  TrailingBlock = 76,
  VariableName = 78,
  ArgList = 79,
  LayerDefinition = 81,
  LayerApplyBlock = 82,
  apply = 83,
  Block = 84,
  TextStatement = 85,
  text = 86,
  TextBlock = 87,
  TspanStatement = 88,
  tspan = 89,
  TextForLoop = 90,
  _for = 91,
  _in = 92,
  TextForEachLoop = 93,
  ForEachDestructure = 94,
  TextIfStatement = 95,
  _if = 96,
  _else = 97,
  TextSwitchStatement = 98,
  TextCaseClause = 99,
  TextDefaultClause = 100,
  LetDeclaration = 101,
  _let = 102,
  _const = 103,
  ArrayDestructure = 104,
  ObjectDestructure = 105,
  ObjectDestructureProp = 106,
  BreakStatement = 108,
  _break = 109,
  ContinueStatement = 110,
  _continue = 111,
  EnumDefinition = 112,
  _enum = 113,
  EnumMember = 114,
  ForLoop = 115,
  ForEachLoop = 116,
  IfStatement = 117,
  ElseClause = 118,
  SwitchStatement = 119,
  CaseClause = 120,
  DefaultClause = 121,
  FunctionDefinition = 122,
  fn = 123,
  ReturnStatement = 124,
  _return = 125,
  PathCommand = 126,
  pathCmd = 127,
  PathCommandLetter = 156,
  WithClause = 146,
  withKw = 147,
  _with = 148,
  CornerOpCall = 149,
  AsClause = 150,
  asKw = 151,
  as = 152,
  LabelCall = 153,
  pathCmdZ = 154,
  ExpressionStatement = 157
